import { render, staticRenderFns } from "./importQuestion.vue?vue&type=template&id=f8e892a8&scoped=true&"
import script from "./importQuestion.vue?vue&type=script&lang=js&"
export * from "./importQuestion.vue?vue&type=script&lang=js&"
import style0 from "./importQuestion.vue?vue&type=style&index=0&id=f8e892a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e892a8",
  null
  
)

export default component.exports